// extracted by mini-css-extract-plugin
export default {"chart":"DonutChart_chart__N4xX9","isAdminchart":"DonutChart_isAdminchart__u4wV5"};